<div class="flex flex-col gap-3">
  @if(isLoading()) {
  <p-skeleton height="150px" />
  } @else { @if(fichando) { @if(recommendedStore) {
  <p-message
    class="mt-3"
    severity="info"
    [text]="'Tienda recomendada por proximidad: ' + recommendedStore.name"
  />
  }
  <div class="flex flex-col gap-1">
    <label>Confirmar tienda Luxoro</label>
    <p-select
      styleClass="w-full"
      appendTo="body"
      [(ngModel)]="selectedStore"
      [options]="stores"
      optionLabel="name"
      placeholder="Tienda"
      [filter]="true"
    ></p-select>
  </div>
  <google-map
    height="300px"
    width="100%"
    [zoom]="zoom"
    [center]="center"
    [options]="mapOptions"
  >
    <map-marker
      *ngFor="let marker of markers"
      [position]="marker.position"
      [title]="marker.title"
      [icon]="marker.icon"
    ></map-marker>
  </google-map>
  <div
    class="bg-primary-50 p-3 border border-primary-300 text-primary-700 border-dashed"
  >
    <p>Hora: {{ horaActual | date : "shortTime" }}</p>
    <p>Ubicación: {{ location }}</p>
    <p>IP: {{ ip }}</p>
    <p>Dispositivo: {{ deviceInfo }}</p>
  </div>
  <div class="mt-5 flex flex-row justify-end">
    <p-button
      [label]="`Iniciar jornada  ${horaActual.toLocaleTimeString()}` "
      [loading]="isUploading"
      [disabled]="!selectedStore || isUploading"
      (onClick)="
        recommendedStore &&
        selectedStore &&
        selectedStore!.uid !== recommendedStore!.uid
          ? confirm1($event)
          : handleFichaje()
      "
    />
  </div>
  <p-confirmdialog />
  } }
</div>
<p-toast />
